<template>
  <div
    class="wrapper"
  >
    <video
      ref="RvVideo"
      muted
      playsinline
      loop
      autoplay
      class="video"
      type="video/mp4"
      aria-hidden="true"
    >
      <source
        :src="`${publicPath}uploads/videos/${src}`"
        type="video/mp4"
      >
    </video>
    <div
      class="overlay overlay-png"
      :style="`opacity: ${pngOverlayOpacity}`"
    />
    <div
      class="overlay"
      :class="overlayColor"
      :style="`opacity: ${overlayOpacity}`"
    />
    <button
      v-show="!isMedia"
      :aria-label="isPlaying ? 'Pause background video' : 'Play background video'"
      class="absolute bottom-0 right-0 flex-c w-24 h-12 lg:w-40 lg:h-24 bg-black focus-b z-10 css3"
      @click="toggleVideo"
    >
      <IconBase
        :icon="isPlaying ? 'PauseIcon' : 'PlayIcon'"
        :color="`white`"
        :height="`14px`"
        :width="`14px`"
      />
      <span class="text-white ml-3 font-normal">{{ isPlaying ? 'Pause' : 'Play' }}</span>
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import IconBase from '@/components/icons/IconBase.vue'

export default {
  name: 'RvBgVideo',

  components: {
    IconBase
  },

  props: {
    src: {
      type: [ String, Boolean ],
      default: 'uploads/looping-background.mp4'
    },
    pngOverlayOpacity: {
      type: Number,
      default: 0.6
    },
    overlayOpacity: {
      type: Number,
      default: 0.8
    },
    overlayColor: {
      type: String,
      default: ''
    },
    poster: {
      type: String,
      default: ''
    }
  },

  watch: {
    isMedia(newVal) {
      if (newVal) {
        this.video.pause()
        this.isPlaying = false
      }

      if (!newVal && this.wasPlaying) {
        this.video.play()
        this.isPlaying = true
      }
    }
  },

  data: () => ({
    publicPath: process.env.BASE_URL,
    isPlaying: true,
    wasPlaying: true
  }),

  computed: {
    ...mapState([ 'isMedia' ]),

    video() {
      return this.$refs.RvVideo
    }
  },

  methods: {
    toggleVideo() {
      if (this.video.paused) {
        this.video.play()
        this.isPlaying = true
        this.wasPlaying = true
      } else {
        this.video.pause()
        this.isPlaying = false
        this.wasPlaying = false
      }
    }
  }
}
</script>

<style scoped>
.wrapper {
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
}

.video {
  height: auto;
  left: 50%;
  max-height: none;
  max-width: none;
  min-height: 100%;
  min-width: 100%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: auto;
}

.overlay {
  min-height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  min-width: 100%;
}

.overlay-png {
  background-image: url('../../src/assets/video-overlay.png');
}
</style>
